import React from "react";
import { useTranslation } from "react-i18next";
import PersonalRecordsCard from "../../../../dashboard/calendar/components/PersonalRecordsCard";
import WorkloadStats from "./WorkloadStats";
import _ from "lodash";
import { WEIGHT_UNITS } from "../../../../../constants";
import { displayDateRange } from "../../../../../utils/questionnaire";
import { convertAndFormatRecordWeights } from "../../../../../utils/workout-stats";

const SummaryPersonalStats = ({ start, end, units, dayPersonalRecords }) => {
  const { t } = useTranslation("athlete-portal");
  // personal records data
  let PRData = {};
  if (dayPersonalRecords) {
    PRData = convertAndFormatRecordWeights(dayPersonalRecords, units);
  }

  return (
    <section className="summary-personal-stats">
      <article id="summary-personal-records">
        <header>
          <h4>{t("personalRecords.title")}</h4>
          <p className="p4">{displayDateRange(start, end)}</p>
        </header>

        <PersonalRecordsCard
          PRData={PRData}
          units={_.capitalize(WEIGHT_UNITS[units])}
          isCheckIn={true}
        />
      </article>
      <WorkloadStats start={start} end={end} />
    </section>
  );
};

export default SummaryPersonalStats;
